import styled from 'styled-components';

export const Wrapper = styled.button<{ noMargin?: boolean }>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin: ${({ noMargin }) => (noMargin ? '0' : '4px 8px')};
  background-color: var(--colorWhite);
  padding: 11px 16px;
  border: 1px solid var(--colorBlueGray200);
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  max-width: 384px;
  transition: border-color 0.2s ease-in-out;

  &:hover,
  &:focus {
    border-color: var(--colorBlueGray600);
  }
`;
